import { useEffect } from 'react';

import useIsWindowVisible from '../../components-yldr/LiquidityChartRangeInput/hooks/useIsWindowVisible';
import { useWeb3Context } from '../../libs/hooks/useWeb3Context';
import { useProtocolDataContext } from '../useProtocolDataContext';

export const useSwitchNetworkOnFocus = () => {
  const { currentChainId } = useProtocolDataContext();
  const { chainId, switchNetwork, loading } = useWeb3Context();
  const windowVisible = useIsWindowVisible();

  useEffect(() => {
    if (!loading && windowVisible && currentChainId !== chainId) {
      switchNetwork(currentChainId);
    }
  }, [currentChainId, chainId, loading, windowVisible]);
}
